import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import type { Period } from 'lumen/models';
import {
  RESTRICTION_MODEL_CONTEXTS,
  RESTRICTION_TYPES,
} from 'lumen/utils/constants/channel-pricing-constants';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';

import styles from './pricing-assistant-table-tooltip.module.css';

interface HotelPricingAssistantTableTooltipsTooltipStayRestrictionsTableSignature {
  Args: {
    period: Period;
  };
}

export default class HotelPricingAssistantTableTooltipsTooltipStayRestrictionsTable extends Component<HotelPricingAssistantTableTooltipsTooltipStayRestrictionsTableSignature> {
  @service declare featureToggle: Services['feature-toggle'];

  get hotelLevelMinLos(): number | null {
    if (
      !this.featureToggle.hasFeatureToggle(
        FEATURE_TOGGLES.MIN_LOS_STAY_RESTRICTION_TOOLTIP,
      )
    ) {
      return null;
    }

    const hotelLevelRecommendation =
      this.args.period.restrictionRecommendations.find(
        (recommendation) =>
          recommendation.context === RESTRICTION_MODEL_CONTEXTS.HOTEL_LEVEL,
      );

    const minLosValue = hotelLevelRecommendation?.values.find(
      (recommendation) => recommendation.type === RESTRICTION_TYPES.MIN_LOS,
    )?.value;

    return typeof minLosValue === 'number' ? minLosValue : null;
  }

  <template>
    {{#if this.hotelLevelMinLos}}
      <table
        class="default-table {{styles.table}}"
        data-test-stay-restrictions-section
      >
        <thead>
          <tr>
            <th class="{{styles.table-header}} text-200--bold">
              {{t "pricing_assistant.stay_restrictions.header"}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="{{styles.table-row-cell}} text-200--regular">
              <p class="text-200--regular">
                {{t "general.hotel"}}
              </p>
              <p
                class="text-200--regular"
                data-test-stay-restrictions-hotel-value
              >
                {{t
                  "pricing_assistant.stay_restrictions.min_los"
                  count=this.hotelLevelMinLos
                }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    {{/if}}
  </template>
}
